"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomExpectedValueSelector = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const react_1 = require("react");
const CustomExpectedValueSelector = ({ inputLabel, collapsedWidth, options, onChange, value, renderOption, ...props }) => {
    const [autocompleteElem, setAutocompleteElem] = (0, react_1.useState)(null);
    const textFieldRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(material_1.Autocomplete, { ...props, ref: (ref) => setAutocompleteElem(ref), value: value, multiple: true, popupIcon: null, clearIcon: null, forcePopupIcon: false, selectOnFocus: false, openOnFocus: true, componentsProps: {
            popper: {
                sx: {
                    [`.${material_1.autocompleteClasses.paper}`]: {
                        width: autocompleteElem?.getBoundingClientRect().width,
                    },
                },
                className: design_system_1.fluidFontClassName,
            },
        }, clearOnBlur: false, onChange: onChange, options: options, renderTags: () => (0, jsx_runtime_1.jsx)(material_1.Box, {}), renderOption: renderOption, renderInput: ({ InputProps, ...otherProps }) => {
            const expanded = textFieldRef.current === document.activeElement ||
                textFieldRef.current?.value;
            return ((0, jsx_runtime_1.jsx)(design_system_1.TextField, { ...otherProps, InputProps: {
                    ...InputProps,
                    inputRef: textFieldRef,
                    sx: ({ palette, transitions }) => ({
                        height: 42,
                        transition: transitions.create(["width", "background-color"]),
                        padding: "0 16px !important",
                        fill: palette.gray[50],
                        [`.${material_1.inputBaseClasses.input}`]: {
                            fontSize: "14px !important",
                            p: "0 !important",
                            ...(!expanded ? { cursor: "pointer !important" } : {}),
                        },
                        ...(!expanded
                            ? {
                                width: collapsedWidth,
                                cursor: "pointer !important",
                                "&:hover": {
                                    background: palette.gray[20],
                                    fill: palette.gray[80],
                                },
                            }
                            : {}),
                        "& ::placeholder": {
                            paddingLeft: 0,
                            transition: transitions.create(["padding-left", "color"]),
                            ...(!expanded
                                ? {
                                    paddingLeft: 0.5,
                                    color: `${palette.gray[80]} !important`,
                                    fontWeight: 500,
                                }
                                : {}),
                        },
                    }),
                    endAdornment: ((0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: expanded ? free_solid_svg_icons_1.faSearch : free_solid_svg_icons_1.faPlus, sx: {
                            fontSize: 14,
                            marginLeft: 1,
                            marginRight: 0.5,
                            fill: "inherit",
                        } })),
                }, placeholder: !expanded ? inputLabel : "Start typing to see more options..." }));
        } }));
};
exports.CustomExpectedValueSelector = CustomExpectedValueSelector;
